import { sis_thangdiem } from './../../../models/response/so-diem/sis_thangdiem';
export enum eThangDiemActionTypeIds {
    LOAD_START = "THANG_DIEM_LOAD_START",
    LOAD_SUCCESS = "THANG_DIEM_LOAD_SUCCESS",
    LOAD_ERROR = "THANG_DIEM_LOAD_ERROR",
}
export interface IThangDiemLoadStart {
    type: eThangDiemActionTypeIds.LOAD_START
}
export interface IThangDiemLoadSuucess {
    type: eThangDiemActionTypeIds.LOAD_SUCCESS,
    payload: sis_thangdiem[]
}
export interface IThangDiemLoadError {
    type: eThangDiemActionTypeIds.LOAD_ERROR,
    payload: string
}
export type IThangDiemActionTypes = IThangDiemLoadStart | IThangDiemLoadSuucess | IThangDiemLoadError